import React from "react";
import styled from "styled-components";

import { Button, Toolbar } from "@examspark/common-ui";
import { IconRefreshLine } from "@examspark/common-ui/dist/components/icons";

const Styled = styled.div`
  padding: 5rem;
  box-sizing: border-box;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;

  & > div {
    max-width: 50rem;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 2rem;
  }

  h1 {
    font-weight: 300;
    font-size: 3rem;
    margin: 0;
    color: #222;
  }
  p {
    font-size: 1.8rem;
    line-height: 1.5em;
    color: #333;
    margin: 0;
    font-weight: 300;
  }
`;

const ApplicationError = (props: {
  appName?: string;
  buttons?: React.ReactNode;
  title?: React.ReactNode;
  message?: React.ReactNode;
}) => {
  return (
    <Styled>
      <div>
        <h1>
          {props.title ??
            `${props.appName ?? "We've"} encountered an error. 🙁`}
        </h1>
        <p>
          {props.message ??
            `Our team has been notified. Reload ${props.appName} to try again.`}
        </p>
        <Toolbar>
          {props.buttons ?? (
            <Button
              title="Return to Dashboard"
              color="primary"
              onClick={() => {
                window.location.href = "/";
              }}
              icon={<IconRefreshLine />}
            >
              Reload {props.appName}
            </Button>
          )}
        </Toolbar>
      </div>
    </Styled>
  );
};

export default ApplicationError;
